<template>
  <div>
    <div class="content">
      <div style="flex: 1;">
        <div>
          <div v-if="data.item.listType === 3">
            <el-select v-model="value" style="width: 100%;" :disabled="!data.item.editable" filterable remote clearable
              placeholder="请输入关键词" :multiple='multi' :remote-method="remoteMethod" :loading="loading" @change="getVal">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <span v-else-if="data.item.listType === 2">
            <el-cascader v-model="value" :options="options" :props="props" style="width: 100%;" @change="getCasVal"
              clearable>
            </el-cascader>

          </span>
          <div v-else>
            <el-select v-model="value" style="width: 100%;" :disabled="!data.item.editable" clearable
              :placeholder="$t('message.placeholder.search')" :multiple='multi' @change="getVal">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

        </div>
      </div>
      <div class="button">
        <el-button style="margin-left: 3px;right:0;"
          v-if="data.item.listType != 2 && data.item.editable && data.item.id != 1004008" type="info" size="mini" plain
          @click="openSearchListWindow(data.item)">{{ $t("message.button.search") }}</el-button>
      </div>
    </div>

    <el-dialog v-if="searchAddList" class="searchAddList" :title="$t('message.title.add')" :visible.sync="searchAddList"
      :close-on-click-modal="!searchAddList" :close-on-press-escape="false">
      <searchListValues ref="searchList" @listDbClick="addToListDisplay" :listInfo="listInfo" />

    </el-dialog>
    <!--  -->
  </div>
</template>

<script>
import axios from 'axios';
import searchListValues from "@/components/searchListValues.vue"

export default {
  data() {
    return {
      options: [],
      value: '',
      loading: false,

      listInfo: {},
      searchAddList: false,
      props: {},
      multi: false,
      baseListEntries: []
    }
  },
  // computed: {
  //   multi() {
  //     this.data.item.name == '用户多选' && console.log(this.data.item);
  //     return this.data.item.uiType == 4
  //   }
  // },
  components: {
    searchListValues,
  },
  props: ['data'],
  methods: {

    addToListDisplay(e) {

      console.log(e, this.value);
      this.searchAddList = false;
      const arr = this.options.map(i => i.value)
      if (this.value == e.listId || (this.multi && this.value.includes(e.listId))) {
        return
      }
      !arr.includes(e.listId) && this.options.push({ 'value': e.listId, 'label': e.listValue })

      let val = '';
      if (!this.multi) {
        this.value = e.listId;
        val = e.listId
      } else {
        this.value.push(e.listId)
        val = this.value.join(';')
      }
      this.$emit('change', { val, item: this.data.item })

    },

    openSearchListWindow(item) {
      this.searchAddList = true;
      this.listInfo = item;
    },

    getBaseInfo() {
      const { item, val } = this.data;
      this.multi = item.uiType === 4
      if (!item.editable && !item.listEntrie) {
        item.listEntrie = [{ id: val.val, name: val.id }]
      }
      const arr = item.listEntrie || [];
      arr.map((i, e) => {
        this.$set(this.options, e, { 'value': i.id, 'label': i.name })
      })

      if (!val) {
        this.value = item.uiType === 4 ? [] : '';
      } else {
        this.value = val
      }

      if (item.listType === 3) {
        if (!val) {
          this.options = [];
        } else {
          if (item.uiType == 3) {
            this.options = [{ value: val, label: item.val.val }]
          } else {
            if (!item.val.val) {
              this.options = []
              this.value = []
            } else {
              const lableList = item.val.val.split(';');
              this.options = val.map((i, e) => ({ value: i, label: lableList[e] }))
            }
          }
        }
      } else if (item.listType === 2) {
        this.options = item.listEntrie
        this.props = item.uiType === 4 ? { multiple: true } : {};
        if (item.uiType === 4) {
          // console.log(val);
          this.value = val.map(i => {
            return this.getParentIdList(this.options, i);
          })
        }
      }
      // console.log({ n: item.name, u: item.uiType, v: this.value, val });
    },

    // async getList(){
    //   const {data} = await axios.get('pmdm/admin/list/getEnabledListEntryByListId?listId=10085')
    //   return data
    // },
    getCasVal(e) {
      console.log(e,);
      let val = ''
      if (!e) {
        return
      } else {
        if (this.data.item.uiType === 4) {
          val = e.map(i => i[i.length - 1]).join(';')

        } else {
          val = e[e.length - 1] + ''
        }
      }
      this.$emit('change', { val, item: this.data.item })
    },
    getVal(e) {
      const val = this.data.item.uiType === 4 ? e.join(';') : e;
      this.data.item.listType === 3 && (this.options = [])
      this.$emit('change', { val, item: this.data.item })
    },

    getListEntries(list, query) {
      const arr = list.filter(item => {
        return item.entryValue.toLowerCase()
          .indexOf(query.toLowerCase()) > -1;
      }).map(i => ({ value: i.listId + '_' + i.entryId, label: i.entryValue }));
      return arr
    },
    async remoteMethod(query) {

      if (!this.baseListEntries.length) {
        if (query !== '') {
          this.loading = true;
          const id = this.data.item.listId;
          const { data } = await axios.get('pmdm/admin/list/getEnabledListEntryByListId?listId=' + id);
          this.baseListEntries = data.object.listEntries;
          this.options = this.getListEntries(this.baseListEntries, query);
          this.loading = false
        } else {
          this.options = [];
        }
      } else {
        this.options = this.getListEntries(this.baseListEntries, query);
      }
    }
  },
  mounted() {
    this.getBaseInfo();
    // console.log(this.data);
  }

}
</script>

<style scoped>
.content {
  width: 100%;
  display: flex;
}

.content.button {
  flex-basis: 60px;
  flex-shrink: 0;

}
</style>